import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { PostEditorReducerFunction, PostEditorToggleCustomizePerProfileAction } from '../PostEditorActions';
import { canAddComment } from '../../helpers/canAddComment';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

export const customizePerProfileReducer: PostEditorReducerFunction<
  PostEditorToggleCustomizePerProfileAction['payload']
> = (state, payload) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, type, selectedProfiles } = payload;

  const groupPropName = type === 'scheduling' ? 'customizeSchedulePerProfile' : 'customizeContentPerProfile';
  const oppositeGroupPropName = type === 'scheduling' ? 'customizeContentPerProfile' : 'customizeSchedulePerProfile';
  const newValue = !state.postGroups[postGroupIndex][groupPropName];
  let result = updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        [groupPropName]: {
          $set: newValue
        }
      }
    }
  });
  if (newValue) {
    for (let i = 0; i < state.postGroups[postGroupIndex].profiles.length; i++) {
      // we need to check if the profileId already exists in posts.
      // e.g. we have customize content per profile on, and we switched on customize schedule
      const findIndex = state.postGroups[postGroupIndex].posts.findIndex(
        post => post.customizedProfileId === state.postGroups[postGroupIndex].profiles[i].profileId
      );
      const selectedProfile = selectedProfiles.find(
        profile => profile.id === state.postGroups[postGroupIndex].profiles[i].profileId
      );
      const feedType = state.postGroups[postGroupIndex].groupPostAttributes.content.postFeedType;
      const canShowComment = selectedProfile ? canAddComment([selectedProfile], feedType) : false;
      const showFirstComment =
        state.postGroups[postGroupIndex].groupPostAttributes.content.shouldShowFirstComment && canShowComment;
      // update show first comment depending on the profile type
      if (findIndex < 0) {
        result = updateImmutable(result, {
          postGroups: {
            [postGroupIndex]: {
              posts: {
                $push: [
                  updateImmutable(result.postGroups[postGroupIndex].groupPostAttributes, {
                    $merge: {
                      customizedProfileId: state.postGroups[postGroupIndex].profiles[i].profileId
                    },
                    content: {
                      shouldShowFirstComment: {
                        $set: showFirstComment
                      }
                    }
                  })
                ]
              }
            }
          }
        });
      } else {
        const newType = result.postGroups[postGroupIndex].groupPostAttributes[type];
        result = updateImmutable(result, {
          postGroups: {
            [postGroupIndex]: {
              posts: current =>
                current.map(post =>
                  updateImmutable(post, {
                    [type]: {
                      $set: newType
                    }
                  })
                )
            }
          }
        });
      }
    }
  } else if (!state.postGroups[postGroupIndex][oppositeGroupPropName]) {
    // neither customize content, nor customize schedule active, reset posts to an empty array
    result = updateImmutable(result, {
      postGroups: {
        [postGroupIndex]: {
          posts: {
            $set: []
          }
        }
      }
    });
  }
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning);
};
